<template>
  <textfield-screen
    :key="'phoneNumber'"
    id="phoneNumber"
    v-model="username"
    :title="title"
    :is-not-valid="isNotValid"
    :is-not-valid-message="isNotValidMessage"
    :disabledNextButton="isLoading"
    inputmode="email"
    :maxlength="50"
    :headerImg="1"
    autocomplete="off"
    @next="validLogin"
    @back="back"
    @blur="autofixPhone"
  >
    <template slot="middle" v-if="!isEmail">
      <p class="helptext">{{ $ml.get('enterLoginPhoneHelpText') }}</p>
    </template>
    <template slot="bottomLink">
      <a v-if="isEmail" class="link" v-text="$ml.get('addEmailLater')" @click.prevent="nextRegisteredScreen">Додати адресу пізніше</a>
    </template>
  </textfield-screen>
</template>

<script>
import Vue from 'vue';
import TextfieldScreen from '../../components/layout/textfield-screen';
import {conformToMask} from 'vue-text-mask';
import Profile from '../../helpers/profile';
import {sendSecondOtpCode, getApiErrorMessage, registerProfile as apiRegisterProfile, sendThirdOtpCode} from '../../helpers/api';

export default {
  name: 'enterPhoneEmailPage',
  components: {TextfieldScreen},
  data() {
    return {
      isEmail: Profile.process === 'accessRecovery' ? (Profile.needsetphone && Profile.secondOTP.username) || (!Profile.needsetphone && Profile.needsetemail) : Profile.otptype !== 'email',
      isNotValid: false,
      isNotValidMessage: '',
      timeoutShowError: null,
      isLoading: false,
      username: '',
    };
  },

  computed: {
    title: function() {
      return this.isEmail ? this.$ml.get('addEmailTitle') : this.$ml.get('addPhoneTitle');
    },
  },

  watch: {
    username: function(val) {
      Vue.nextTick(() => {
        this.username = this.isEmail ? val.replace(/[^A-Za-z\.\d-_\@]/g, '') : val.replace(/\D/g, '');
      });
    },
  },

  mounted() {},

  methods: {
    autofixPhone: function() {
      if (/^[0-9]{9}$/.test(this.username)) this.username = '380' + this.username;
    },

    validLogin: function(data) {
      let val = data.value;
      if (/^\+?\d+$/.test(val) && !this.isEmail) {
        this.autofixPhone();
        val = this.username;
        if (/^380[0-9]{9}$/.test(val)) this.sendCode('sms', val);
        else this.showNotValidMessage(this.$ml.get('enterLoginErrorPhone'));
      } else if (val.length > 0) {
        if (val.match(/^.+@([\w\-]+\.){0,3}[a-z]{2,7}$/i)) {
          this.sendCode('email', val.toLowerCase());
        } else {
          this.showNotValidMessage(this.$ml.get('enterLoginErrorEmail'));
        }
      } else {
        this.showNotValidMessage(this.$ml.get('enterLoginErrorEmpty'));
      }
    },

    showNotValidMessage: function(text) {
      if (!text) {
        clearTimeout(this.timeoutShowError);
        return;
      }
      this.isNotValidMessage = text;
      this.isNotValid = true;
      this.timeoutShowError = setTimeout(() => {
        this.isNotValid = false;
      }, 2000);
    },

    sendCode: function(type, val) {
      this.isLoading = true;
      if (Profile.process === 'accessRecovery') {
        this.sendRecoveryCode(type, val);
      } else {
        Profile.setData({
          secondOTP: {
            username: val,
            otpcode: '',
            otptype: type,
            otpsend: false,
          },
        });
        sendSecondOtpCode()
          .then(
            resp => {
              if (Profile.process === 'login') this.$router.push('/login/enterSecondCode');
              else this.$router.push('/registration/sendCode');
            },
            err => {
              this.showNotValidMessage(
                getApiErrorMessage(err, {
                  //                        '400': this.$ml.get(Profile.otptype === 'sms' ? 'enterLoginErrorPhone' : 'enterLoginErrorEmail')
                })
              );
            }
          )
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    sendRecoveryCode: function(type, val) {
      this.isLoading = true;
      if (this.isEmail) {
        Profile.setData({
          thirdOTP: {
            username: val,
            otpcode: '',
            otptype: type,
            otpsend: false,
          },
        });
        sendThirdOtpCode()
          .then(
            resp => {
              this.$router.push('/accessRecovery/sendThirdCode');
            },
            err => {
              this.showNotValidMessage(getApiErrorMessage(err));
            }
          )
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        Profile.setData({
          secondOTP: {
            username: val,
            otpcode: '',
            otptype: type,
            otpsend: false,
          },
        });
        sendSecondOtpCode()
          .then(
            resp => {
              this.$router.push('/accessRecovery/sendSecondCode');
            },
            err => {
              this.showNotValidMessage(getApiErrorMessage(err));
            }
          )
          .finally(() => {
            this.isLoading = false;
          });
      }
    },

    nextRegisteredScreen: function() {
      if (this.isLoading) return;
      if (Profile.process === 'accessRecovery') {
        this.$router.push('/accessRecovery/infoPinCode');
        return;
      }
      this.isLoading = true;
      apiRegisterProfile(true)
        .then(
          () => {
            this.$router.push({name: 'RegistrationFinish'});
          },
          err => {
            this.showNotValidMessage(
              getApiErrorMessage(err, {
                '406': this.$ml.get('errorUserAlreadyExist'),
              })
            );
          }
        )
        .finally(() => {
          this.isLoading = false;
        });
    },

    back: function() {
      if (this.$route.path == '/registration/enterEmailPage') {
        this.$router.back();
      } else if (Profile.process === 'registration') {
        Profile.setData({otpsend: true});
        this.$router.replace({name: 'LoginEnterLogin'});
      } else this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.helptext {
  margin-top: 42px;
  text-align: left;
}
.faceId {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  p {
    font-weight: 500;
  }
  svg {
    margin-right: 12px;
  }
}
.link {
  color: #5cd69b;
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  margin: 12px 0;
  display: inline-block;
}
@media (min-width: 601px) and (max-width: 750px) {
  .faceId {
    display: none;
  }
  .link {
    font-weight: 500;
  }
}
@media (min-width: 751px) {
  .helptext {
    margin-top: 16px;
  }
  .faceId {
    display: none;
  }
  .link {
    font-weight: 500;
  }
}
</style>
